{
  "dashboard": {
    "section_title": "Vos opportunités",
    "stats": {
      "total_open": "Total des opportunités ouvertes",
      "total_won": "Total des opportunités gagnées",
      "success_rate": "Votre taux de réussite",
      "loading": "Chargement des statistiques d'opportunités..."
    },
    "create": {
      "reminder_title": "N'oubliez pas de suivre vos opportunités.",
      "reminder_description": "Avez-vous reçu une recommandation, eu un retour d’un client potentiel ou identifié une autre opportunité commerciale ? Suivez-la ici pour rester organisé et assurer un suivi efficace.",
      "button_text": "Créer une nouvelle opportunité"
    }
  },
  "basic_opportunities_page": {
    "advanced_button": "Avancé",
    "create_opportunity_button": "Créer une opportunité",
    "all_opportunities_tab": "Toutes les opportunités"
  },
  "archive_opportunity": {
    "confirm_content": "Cette action ne peut pas être annulée",
    "confirm_title": "Êtes-vous sûr de vouloir archiver cette opportunité ?",
    "archive_title": "Archiver l'opportunité"
  },
  "duplicate_goal": {
    "header": "Dupliquer l'opportunité",
    "aria_label": "dupliquer l'opportunité",
    "title": "Dupliquer l'opportunité"
  },
  "opportunity_grid": {
    "actions_menu": {
      "opportunity_actions": "Actions d'opportunité",
      "actions": "Actions",
      "update": "Mettre à jour",
      "duplicate": "Dupliquer",
      "archive": "Archiver"
    },
    "filters": {
      "assign_to": "Assigner à",
      "referral_source": "Source de référence",
      "date": "Date",
      "search_placeholder": "Rechercher"
    },
    "columns": {
      "title_description": "Titre/Description",
      "opportunity_date": "Date de l'opportunité",
      "internal_owner": "Propriétaire interne",
      "internal_owner_email": "Propriétaire interne (E-mail)",
      "team_involved": "Équipe impliquée",
      "team_involved_email": "Équipe impliquée (E-mail)",
      "internal_owner_department": "Département du propriétaire interne",
      "internal_owner_office": "Bureau du propriétaire interne",
      "status": "Statut",
      "referral_source_email": "Source de référence (E-mail)",
      "created_by_email": "Créé par (E-mail)",
      "last_updated": "Dernière mise à jour",
      "last_meeting": "Dernière réunion",
      "last_sent_email": "Dernier e-mail envoyé",
      "last_received_email": "Dernier e-mail reçu",
      "company": "Entreprise",
      "tracking_number": "Numéro de suivi",
      "tags": "Étiquettes",
      "company_type": "Type d'entreprise",
      "company_industries": "Industries de l'entreprise",
      "company_internal_industries": "Industries internes de l'entreprise",
      "company_engagement": "Engagement de l'entreprise",
      "key_contacts": "Contacts clés",
      "key_contact_names": "Noms des contacts clés",
      "key_contact_emails": "E-mails des contacts clés",
      "key_contact_name": "Nom du contact clé",
      "key_contact_email": "E-mail du contact clé",
      "key_contact_country": "Pays du contact clé",
      "key_contact_city": "Ville du contact clé",
      "key_contact_job_title": "Titre du poste du contact clé",
      "fee": "Honoraires",
      "referral_source": "Source de référence",
      "created_by": "Créé par",
      "referral_source_company": "Entreprise source de référence",
      "last_interaction": "Dernière interaction"
    }
  },
  "opportunity_preview": {
    "created_by": "Créé par {{name}} le {{date}}",
    "update_opportunity": "Mettre à jour l'opportunité",
    "create_note": "Créer une note",
    "opportunity_number": "Opportunité #{{trackingNumber}}",
    "opportunity_for": "Opportunité pour",
    "proposal_for": "Proposition pour",
    "industries": "Industries",
    "status": "Statut",
    "internal_owner": "Propriétaire interne",
    "key_contacts": "Contacts clés",
    "title_description": "Titre / Description",
    "tags": "Étiquettes",
    "proposed_fee": "Honoraires proposés",
    "team_involved": "Équipe impliquée",
    "referral_source": "Source de référence",
    "proposal_documents": "Documents de proposition",
    "linked_workspaces": "Espaces de travail liés",
    "share_opportunity": "Partager l'opportunité",
    "duplicate_opportunity": "Dupliquer l'opportunité",
    "archive_opportunity": "Archiver l'opportunité",
    "details": "Détails",
    "history": "Historique",
    "notes": "Notes",
    "link": "Lien",
    "view_original_email": "Voir l'e-mail original"
  },
  "add_document_ui": {
    "add_document_header": "Ajouter un document",
    "add_document_aria_label": "ajouter un document",
    "or_separator": "- ou -"
  },
  "add_urls": {
    "document_urls_label": "URLs de documents (multiples)"
  },
  "custom_status": {
    "show_opportunities_aria": "afficher les opportunités {{name}}",
    "total": "Total",
    "opportunities_short": "Opps",
    "showing_opportunities_tooltip": "Affichage de {{showing}} opportunités. Basculez vers la vue Liste pour voir toutes les {{total}} opportunités",
    "check_all_opportunities": "Vérifier toutes les {{count}} opportunités",
    "last_interaction": "Dernière interaction :",
    "no_amount": "-"
  },
  "grid": {
    "loading_alt_text": "Chargement des opportunités"
  },
  "form": {
    "opportunity": "Opportunité",
    "select_company_required": "Sélectionner une entreprise associée *",
    "status": "Statut",
    "key_contacts": "Contacts clés",
    "description": "Description",
    "description_placeholder": "Décrivez votre opportunité en une phrase",
    "tags": "Étiquettes",
    "proposed_fee": "Honoraires proposés",
    "opportunity_date": "Date de l'opportunité",
    "date_placeholder": "date",
    "internal_owner": "Propriétaire interne",
    "internal_owner_placeholder": "Qui sera responsable de cette opportunité ?",
    "team_involved": "Équipe impliquée",
    "team_involved_placeholder": "Équipe impliquée dans cette opportunité ?",
    "referral_source": "Source de référence",
    "referral_source_placeholder": "Qui a référé cette opportunité ?",
    "key_contacts_placeholder": "Contacts clés de l'entreprise associée",
    "company_search_placeholder": "Tapez pour rechercher une entreprise",
    "reassign_opportunity": "Réassigner l'opportunité",
    "reassigned_opportunity": "Opportunité réassignée",
    "company": "Entreprise",
    "key_contacts_optional": "Contacts clés (Optionnel)"
  },
  "view": {
    "opportunity_view_aria": "vue d'opportunité",
    "list_view_aria": "vue liste",
    "board_view_aria": "vue tableau",
    "list": "Liste",
    "board": "Tableau"
  },
  "validation": {
    "company_required": "Veuillez saisir une entreprise"
  },
  "audit_trail": {
    "no_history": "Aucun historique n'est disponible pour cette opportunité",
    "categories": {
      "file_uploaded": "fichier téléchargé",
      "note_archived": "note archivée",
      "note_created": "note créée",
      "note_updated": "note mise à jour",
      "opportunity_activity": "activité d'opportunité",
      "opportunity_created": "opportunité créée"
    }
  },
  "notes": {
    "delete": {
      "confirmation_title": "Êtes-vous sûr de vouloir supprimer cette note ?"
    },
    "actions": {
      "aria_label": "actions de note d'opportunité"
    },
    "added_by": "{{name}} a ajouté une note"
  },
  "load_limit": {
    "message": "Il y a plus d'opportunités que celles affichées. Veuillez affiner la plage de dates des opportunités pour voir les résultats pertinents."
  }
}
